export enum GrupoEnum { ADMIN = "ADMIN", CUSTOMER = "CUSTOMER" }
